const T_PREFIX = "blog";

export const blogTrns = {
  title: `${T_PREFIX}.title`,
};

export const searchTrns = {
  placeholder: `${T_PREFIX}.search.placeholder`,
};

export const categoriesTrns = {
  title: `${T_PREFIX}.categories.title`,
};

export const noSearchResultsTrns = {
  title: `${T_PREFIX}.no-search-results.title`,
  subtitle: `${T_PREFIX}.no-search-results.subtitle`,
};
